module.exports = __webpack_public_path__ + "img/e48.b498410d.png";